<div class="fulfillmentLanding xs-mt-0 xs-mb-40">

  <div class="row">
    <div class="col-md-12 col-lg-12 d-md-none padding-t10 margin-sm-l10 mt-3"><h3 class="m-0"> Seed Orders </h3></div>
    <div class="col-md-12 dashboard-outer">
      <div class="order-listing margin-t20">
        <div class="row js-searchWrapper">
          <div class="col-lg-6">
            <div class="search-box landingPageSearch landingPageSearchTop xs-mt-0 lg-mt-20" [ngClass]="{'opened' : isOpenFirst}">
              <form name="" action="">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <input type="hidden" #selectAccountHidden />
                <div class="select-container material-select">
                  <ng-select #select name="ddlAccount" [items]="accountSearchData"
                             [(ngModel)]="ddlSelectedAccountId"
                             [virtualScroll]="true"
                             bindLabel="accountNameCityState"
                             bindValue="accountNumber"
                             [loading]="accountLoading"
                             (change)="accountSearchOnClose($event);"
                             (clear)="accountSearchOnClear($event)"
                             class="custom-select-grower searchIcon lpSearch"
                             placeholder="Select Account"
                             [closeOnSelect]="true"
                             [searchFn]="accountSearchFn"
                             (open)="onOpen(); topOpen()"
                             (close)="onClose(); topClose()">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <h4 class="name greenColor" [ngOptionHighlight]="search">
                              {{item.accountName}}
                              <span class="erp-order" *ngIf="item.wfusB2BEnablement == 'Yes'">
                                <i class="fas fa-lock"></i>
                              </span>
                            </h4>
                            <p class="address" [ngOptionHighlight]="search">
                              {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                            </p>
                            <p class="phoneNo" [ngOptionHighlight]="search">
                              {{item.primaryPhoneNumber}}
                            </p>
                            <p class="grower-nos">
                              <span class="grower-gln" [ngOptionHighlight]="search">
                                Account #: {{item.accountNumber}}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                    <ng-template ng-footer-tmp let-search="searchTerm">
                      <div class="custom-drop-footer">
                        <div class="row">
                          <div class="col-md-12">
                            Select an option above to filter
                          </div>

                          <!--<div class="col-md-4 bold text-right">-->
                          <!-- 32 Results -->
                          <!--{{this.accountDataCount}} Results
                          </div>-->
                        </div>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </form>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="search-box landingPageSearch xs-mt-0 lg-mt-20" [ngClass]="{'opened' : isOpenSecond}">
              <form name="" action="">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <input type="hidden" #selectGrowerHidden />
                <div class="select-container material-select">
                  <ng-select name="ddlGrowerDetails"
                             [items]="growerList"
                             [(ngModel)]="growerGMK"
                             [virtualScroll]="true"
                             bindLabel="growerNameCityState"
                             placeholder="Select Grower"
                             [loading]="growerLoading"
                             bindValue="gmk"
                             class="custom-select-grower searchIcon lpSearch"
                             [searchFn]="growerSearchFn"
                             [closeOnSelect]="true"
                             (search)="search($event)"
                             (change)="onGrowerSelection($event)"
                             (open)="onOpen(); middleOpen()"
                             (close)="onClose(); middleClose()">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <h4 class="name greenColor" [ngOptionHighlight]="search">
                              {{item.businessName?.toUpperCase()}}
                            </h4>
                            <p class="address" [ngOptionHighlight]="search">
                              {{item.address1?.toUpperCase()}},  {{item.city?.toUpperCase()}}, {{item.state?.toUpperCase()}} - {{item.zip}}
                            </p>
                            <p class="phoneNo" [ngOptionHighlight]="search">
                              {{item.primaryPhoneNumber}}
                            </p>
                            <p class="grower-nos">
                              <span class="grower-gln" [ngOptionHighlight]="search">
                                Grower GMK: {{item.gmk}}
                              </span>
                              <span class="grower-gln" [ngOptionHighlight]="search">
                                Grower GLN: {{item.growerGLN}}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="selectedTabIndex === 0">
          <div class="col-12 d-sm-block d-md-none margin-t10 margin-b10">
            <button mat-raised-button class="btns wide100" style="height: 50px; font-size: 16px;" [style.display]="accessTypeMode ? 'none' : 'block'" (click)="createNewOrder()" data-testid="btn-create-new-grower-order">Create New Grower Order</button>
          </div>
        </div>

        <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs margin-t10" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="tabChanged($event)">

          <mat-tab *ngIf="growerAccessTypeMode">
            <ng-template mat-tab-label>
              <i class="icon-ico-grower_icon" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                  Grower Orders
                </h4>
                <p class="subhead">
                  Manage your Grower Orders
                </p>
              </div>
            </ng-template>
            <div class="order-top-sec">
              <div class="row listing-action-items">
                <div class="col-xl-2 col-lg-2 col-md-2">
                  <div class="selectAllcheckSec hidden">
                    <mat-checkbox (change)="$event ? masterToggleGrower() : null"
                                  [checked]="selection.hasValue() && isAllGrowerOrderSelected()"
                                  [indeterminate]="selection.hasValue() && !isAllGrowerOrderSelected()" class="custom-checkbox select-all-check">
                    </mat-checkbox>
                    <i class="fas fa-sort-down light-gray-arrow" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-7 text-right">
                  <mat-paginator #growerPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-3 pr-0 text-right smallPadLeft0 d-none d-md-block">
                  <button mat-raised-button class="btns" [style.display]="accessTypeMode ? 'none' : 'block'" (click)="createNewOrder()" data-testid="btn-create-new-grower-order">Create New Grower Order</button>
                </div>
              </div>
            </div>
            <div class="tableContainer growertableContainer table-mobile-landing">
              <table mat-table #growerTable [dataSource]="growerOrderDataSource" matSort matSortDirection="desc" class="matTables">
                <ng-container matColumnDef="growerName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="growerName seed-grid-header"> Grower </th>
                  <p class="d-sm-block d-md-none">Grower</p>
                  <td mat-cell *matCellDef="let element" class="order-info showOnMobile" (click)="navigateToSingleAccount(element)">
                    <p class="grower-name">
                      <a>
                        <p class="d-sm-block d-md-none">Grower</p>
                        {{element.growerName}}
                      </a>
                    </p>
                    <p>{{element.growerAddress}}</p>
                  </td>
                </ng-container>
                <ng-container matColumnDef="orderType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="erpOrder">&nbsp;</th>
                  <td mat-cell *matCellDef="let element" class="d-none d-md-table-cell">
                    <span class="erp-order" *ngIf="element.orderType != 'WB' || element.wfusB2BEnablement == 'Yes' ">
                      <i class="fas fa-lock"></i>
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="shipToAccount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderId seed-grid-header"> Account #</th>
                  <td mat-cell *matCellDef="let element" class="showOnMobile">
                    <p class="d-sm-block d-md-none fontSize" [attr.data-testid]="element.shipToAccount">Account #</p>
                    {{element.shipToAccount}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="orderID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderId seed-grid-header"> Order ID</th>
                  <td mat-cell *matCellDef="let element" class="showOnMobile alignText">
                    <p class="d-sm-block d-md-none fontSize">Order ID</p>
                    <div class="d-sm-inline-block d-md-none" [ngClass]="element.orderType != 'WB' || element.wfusB2BEnablement == 'Yes' ? 'margin-l-20' : ''">
                      <span class="erp-order" *ngIf="element.orderType != 'WB' || element.wfusB2BEnablement == 'Yes' ">
                        <i class="fas fa-lock"> </i>
                      </span><span>{{element.orderID}}</span>
                    </div>
                    <span class="d-none d-md-block" [attr.data-testid]="element.orderID">{{element.orderID}}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="unit">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="euivUnitBg seed-grid-header"> Equiv Units(BG) </th>

                  <td mat-cell *matCellDef="let element" class="text-md-center showOnMobile">
                    <p class="d-sm-block d-md-none fontSize">Equiv Units(BG)</p>
                    {{commonService.getFormatedNumber(element.unit) | number}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="lastUpdatedAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="lastUpdated seed-grid-header"> Last Updated </th>
                  <td mat-cell *matCellDef="let element" class="text-center d-none d-md-table-cell"> {{element.lastUpdatedAt | date:'MM/dd/yyyy' }} </td>
                </ng-container>

                <ng-container matColumnDef="licenseStatus">
                  <th mat-header-cell *matHeaderCellDef class="lastUpdated seed-grid-header">License Status</th>
                  <td mat-cell *matCellDef="let element" class="showOnMobile">
                    <p class="d-sm-block d-md-none mb-2">License Status</p>
                    <div class="license-status-icons">
                      <ng-container [ngSwitch]="element.licenseStatus">
                        <span *ngSwitchCase="'Licensed'" class="status licensed" title="Licensed">
                          <i class="fas fa-check-circle licensed-icon"></i>
                          <span class="rt">Licensed</span>
                        </span>
                        <span *ngSwitchCase="'Unlicensed'" class="status unlicensed" style="cursor:pointer" [ngbTooltip]="licenseTpl" tooltipClass="license-tooltip" container="body" placement="top" triggers="click:outsideClick">
                          <i class="fas fa-exclamation-triangle unlicensed-icon"></i>
                          <span class="rt">Unlicensed</span>
                        </span>
                        <ng-template #licenseTpl>
                          <div class="license-tooltip-content">
                            <p [innerHTML]="getLicenseTooltipMessageHtml(element)" (click)="onLicenseTooltipLinkClick($event)"></p>
                          </div>
                        </ng-template>
                        <span *ngSwitchCase="'Not Applicable'" class="status not-app" title="Not Applicable">
                          <i class="fas fa-ban notapp-icon"></i>
                          <span class="rt">Not Applicable</span>
                        </span>
                        <span *ngSwitchCase="'Pending'" class="status pending" title="Pending">
                          <i class="far fa-clock pending-icon"></i>
                          <span class="rt">Pending</span>
                        </span>
                        <span *ngSwitchDefault class="status unknown">
                          <span class="rt">&nbsp;</span>
                        </span>
                      </ng-container>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="contextMenu">
                  <th mat-header-cell *matHeaderCellDef class="lastUpdated seed-grid-header">&nbsp;</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <!-- Display on all screen sizes -->
                    <div>
                      <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu" (click)="setSelectedGrowerOrderId(element.growerOrderId)">
                        <i class="fas fa-ellipsis-v"></i>
                      </button>
                      <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                        <app-growerGeneratePdf #pdfGenerator [growerId]="selectedGrowerOrderId">
                        </app-growerGeneratePdf>
                        <button mat-menu-item (click)="generatePdf()">Download PDF</button>
                      </mat-menu>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="hideOnMobile"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab *ngIf="dealerAccessTypeMode">
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                  Dealer Orders
                </h4>
                <p class="subhead">
                  Manage your Dealer Orders
                </p>
              </div>
            </ng-template>
            <div class="order-top-sec">
              <div class="row listing-action-items">
                <div class="col-sm-3">
                  <div class="selectAllcheckSec hidden">
                    <mat-checkbox (change)="$event ? masterToggleDealer() : null"
                                  [checked]="dealerSelection.hasValue() && isAllDealerOrderSelected()"
                                  [indeterminate]="dealerSelection.hasValue() && !isAllDealerOrderSelected()" class="custom-checkbox select-all-check">
                    </mat-checkbox>
                    <i class="fas fa-sort-down light-gray-arrow" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="col-sm-9 text-right">
                  <mat-paginator #dealerPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                </div>
              </div>
            </div>

            <div class="tableContainer dealertableContainer table-mobile-dealer">
              <table mat-table #dealerTable [dataSource]="dealerOrderDataSource" matSort matSortDirection="desc" class="matTables">

                <ng-container matColumnDef="retailerName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="growerName seed-grid-header"> Dealer </th>
                  <td mat-cell *matCellDef="let element" class="order-info" (click)="navigateToDealerOrderInfo(element)">
                    <p class="d-sm-block d-md-none fontSize sm-block">Dealer</p>
                    <p class="grower-name">
                      <a>
                        {{element.retailerName}}
                      </a>
                    </p>
                    <p>{{element.retailerAddress1 || element.retailerAddress2}}, {{element.retailerCity}}, {{element.retailerState}} {{element.retailerZipCode}}</p>
                  </td>
                </ng-container>
                <ng-container matColumnDef="shipToAccount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderId seed-grid-header"> Account #</th>
                  <td mat-cell *matCellDef="let element">
                    <p class="d-sm-block d-md-none fontSize">Account #</p>
                    {{element.shipToAccount}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="orderId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderId seed-grid-header"> Order ID</th>
                  <td mat-cell *matCellDef="let element">
                    <p class="d-sm-block d-md-none fontSize">Order ID</p>
                    {{element.orderId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="productCount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center euivUnitBg seed-grid-header"> Products </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <p class="d-sm-block d-md-none fontSize">Products</p>
                    {{element.productCount | number}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="units">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center euivUnitBg seed-grid-header"> Equiv Units(BG) </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <p class="d-sm-block d-md-none fontSize">Equiv Units(BG)</p>
                    {{commonService.getFormatedNumber(element.units) | number}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastUpdatedAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="lastUpdated seed-grid-header"> Last Updated </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <p class="d-sm-block d-md-none fontSize">Last Updated</p>
                    {{element.lastUpdatedAt | date:'MM/dd/yyyy' }}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedDealerColumns;sticky:true;" class="hideOnMobile"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedDealerColumns;"></tr>
              </table>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
